import React, {
  PropsWithChildren,
  HTMLAttributes,
} from 'react';
import clsx from 'clsx';

type Part = 'root' | 'label' | 'content';

type Props = PropsWithChildren & Pick<HTMLAttributes<any>, 'className'> & {
  label: string;
  classes?: Partial<Record<Part, string>>;
};

export default function DetailedItem({
  label,
  children,
  className,
  classes,
}: Props) {
  return (
    <div className={clsx(
      'flex flex-wrap flex-col w-full py-3 text-xs justify-between overflow-x-hidden items-start',
      className,
      classes?.root,
    )}
    >
      <div className={clsx('text-gray-500 font-semibold', classes?.label)}>
        {label}
      </div>
      <div className={clsx('w-full h-8 flex items-center', classes?.content)}>
        {children}
      </div>
    </div>
  );
}
